var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyCircleCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 337"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 37",
    cx: 7.5,
    cy: 7.5,
    r: 6.5,
    stroke: "#1E6EF4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.65523 10.4841C6.50753 10.4841 6.35984 10.4278 6.24723 10.3151L3.58438 7.65207C3.35892 7.42684 3.35892 7.06153 3.58438 6.8363C3.80961 6.61084 4.17515 6.61084 4.40015 6.8363L6.65499 9.09114L10.5998 5.1466C10.825 4.92114 11.1905 4.92114 11.4155 5.1466C11.641 5.37184 11.641 5.73714 11.4155 5.96237L7.063 10.3149C6.95038 10.4275 6.80269 10.4838 6.65499 10.4838L6.65523 10.4841Z",
    fill: "#1E6EF4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyCircleCheck);
export default __webpack_public_path__ + "static/media/daily_circle_check.0902fc5414254d06e7b3913d60993209.svg";
export { ForwardRef as ReactComponent };